<template>
  <ReportChartCard :title="t('report.charts.utilization_goals')">
    <VueApexCharts class="bg-white" type="bar" :options="chartOptionsPercent" :series="seriesPercent" height="350" />
    <VueApexCharts class="bg-white" type="bar" :options="chartOptionsHour" :series="seriesHours" height="350" />
  </ReportChartCard>
</template>

<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { useReportStore } from '@/store/report'
import { useUtilizationGoalsPercentChart } from '@/utils/components/utilization-goals-percent-chart'
import VueApexCharts from 'vue3-apexcharts'
import ReportChartCard from './ReportChartCard.vue'

const { t } = useI18n()
const store = useReportStore()

const { chartOptionsHour, chartOptionsPercent, seriesPercent, seriesHours } = useUtilizationGoalsPercentChart(
  store.getEnergySensorUtilization,
  store.getCompareEnergySensorUtilization,
)
</script>
